import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  rightColumn: {
    position: 'relative',
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1.4,
    textTransform: 'uppercase',
  },

  paragraph: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.27,

    marginTop: 20,
    marginBottom: 40,
    width: 530,
  },

  image: {
    width: 420,
    objectFit: 'cover',

    marginTop: 80,
  },
  highlightText: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 900,
    textTransform: 'uppercase',
    marginBottom: 5,
  },

  // TIMELINE
  timelineContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',

    position: 'relative',

    maxWidth: '355px',
    height: '560px',
    width: '100%',
  },
  timelineLine: {
    position: 'absolute',
    left: 25,
    top: 0,
    bottom: 0,
    width: 2,
    backgroundColor: '#27343d',
    zIndex: 0,
  },
  timelineItem: {
    flexDirection: 'row',
    marginBottom: 40,
    alignItems: 'flex-start',
  },
  iconWrapper: {
    width: 50,
    alignItems: 'center',
    position: 'relative',
  },
  icon: {
    width: 50,
    height: 50,
  },
  verticalLine: {
    position: 'absolute',
    top: 30,
    width: 2,
    height: 80,
    backgroundColor: '#27343d',
  },
  timelineContent: {
    marginLeft: 40,
    flex: 1,
  },
  timelineTitle: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 18,
    color: '#27343d',
    textTransform: 'uppercase',
    width: 120,
  },
  timelineText: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.4,
    color: '#27343d',
    marginTop: 5,
  },
  arrowSymbol: {
    position: 'relative',
    left: 21.2,
    top: -28,
    fontSize: 20,
    color: '#27343d',
    textAlign: 'center',
    marginTop: 10,
  },
});
